import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { AppState } from '@client/common/redux/store';
import { getIsLoggedIn } from '@client/context/redux/redux';
import { fetchProduct, selectProductBySku } from '@client/product/redux/products/full/redux';
import { ProductFullType } from '@client/product/redux/products/full/types';

export const useProductFullEffect = (sku: string): RemoteRecord<ProductFullType> => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const product = useSelector(
    (state: AppState) => selectProductBySku(state, sku),
  );

  useEffect(
    (): void => {
      if (!product.wasStarted) {
        dispatch(fetchProduct({ sku }));
      }
    },
    [sku, isLoggedIn, product.wasStarted],
  );

  return product;
};
